import type { OcrData } from './OcrReviewForm';
import { address, birthDate, cccd12, cccdMatchesBirth, fullName, notFutureVn, validate, vnAfter, vnDate } from '../../utils/validators';

export type OcrRole = 'Nông hộ' | 'Hợp tác xã';
type Role = OcrRole;

/**
 * Every eKYC field is required and format-checked: an AI misread (a wrong
 * digit, a date that does not exist, a CCCD number that contradicts the birth
 * year) must be fixed before the submission can go on.
 */
export function ocrErrors(data: OcrData, role: Role): Partial<Record<keyof OcrData, string>> {
  const e: Partial<Record<keyof OcrData, string>> = {
    hoTen: validate(data.hoTen, [fullName], true, 'họ và tên'),
    soCccd: validate(data.soCccd, [cccd12], true, 'số CCCD'),
    ngaySinh: validate(data.ngaySinh, [birthDate], true, 'ngày sinh'),
    gioiTinh: data.gioiTinh === 'Nam' || data.gioiTinh === 'Nữ' ? undefined : 'Vui lòng chọn giới tính',
    diaChi: validate(data.diaChi, [address], true, 'địa chỉ'),
    ngayCap: validate(data.ngayCap, [vnDate, notFutureVn], true, 'ngày cấp'),
  };
  if (!e.soCccd && !e.ngaySinh) e.soCccd = cccdMatchesBirth(data.soCccd, data.ngaySinh, data.gioiTinh);
  if (!e.ngayCap && !e.ngaySinh) e.ngayCap = vnAfter(data.ngayCap, data.ngaySinh, 'Ngày cấp phải sau ngày sinh');
  if (role === 'Hợp tác xã') {
    e.tenHtx = validate(data.tenHtx ?? '', [], true, 'tên HTX');
    e.maHtx = validate(data.maHtx ?? '', [], true, 'mã HTX');
    e.vaiTroDaiDien = validate(data.vaiTroDaiDien ?? '', [], true, 'vai trò người đại diện');
  }
  return e;
}

export const ocrValid = (data: OcrData, role: Role) => Object.values(ocrErrors(data, role)).every((v) => !v);

